export class InternationalRoadShipmentActivity {
    public id:number|null;
    public international_shipment_id:number;
    public activity_seq:number;
    public perm_shipment_id:number|null;
    public shipment_order:number|null;
    public start_date:Date|null;
    public start_time:Date|null;
    public end_date:Date|null;
    public end_time:Date|null;
    public name:string|null;
    public address:string|null;
    public zip_code:string|null;
    public city:string|null;
    public county:string|null;
    public country_code:string|null;
    // public activity_type:string|null;
    public real_start_date:Date|null;
    public real_start_time:Date|null;
    public real_end_date:Date|null;
    public real_end_time:Date|null;
    public truck:string|null;
    public trailer:string|null;
    public status:string|null;
    public status_detail:string|null;
    // public is_ready:boolean;

    constructor(data:InternationalRoadShipmentActivityData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.international_shipment_id = 0;
            this.activity_seq = 0;
            this.perm_shipment_id = null;
            this.shipment_order = null;
            this.start_date = null;
            this.start_time = null;
            this.end_date = null;
            this.end_time = null;
            this.name = null;
            this.address = null;
            this.zip_code = null;
            this.city = null;
            this.county = null;
            this.country_code = null;
            // this.activity_type = null;
            this.real_start_date = null;
            this.real_start_time = null;
            this.real_end_date = null;
            this.real_end_time = null;
            this.truck = null;
            this.trailer = null;
            this.status = null;
            this.status_detail = null;
            // this.is_ready = false;
        }
        else
        {
            this.id = data.id;
            this.international_shipment_id = data.international_shipment_id;
            this.activity_seq = data.activity_seq;
            this.perm_shipment_id = data.perm_shipment_id;
            this.shipment_order = data.shipment_order;
            this.start_date = data.start_date?(new Date(data.start_date)):null;
            this.start_time = data.start_time?(new Date(data.start_time)):null;
            this.end_date = data.end_date?(new Date(data.end_date)):null;
            this.end_time = data.end_time?(new Date(data.end_time)):null;
            this.name = data.name;
            this.address = data.address;
            this.zip_code = data.zip_code;
            this.city = data.city;
            this.county = data.county;
            this.country_code = data.country_code;
            // this.activity_type = data.activity_type;
            this.real_start_date = data.real_start_date?(new Date(data.real_start_date)):null;
            this.real_start_time = data.real_start_time?(new Date(data.real_start_time)):null;
            this.real_end_date = data.real_end_date?(new Date(data.real_end_date)):null;
            this.real_end_time = data.real_end_time?(new Date(data.real_end_time)):null;
            this.truck = data.truck;
            this.trailer = data.trailer;
            this.status = data.status;
            this.status_detail = data.status_detail;
            // this.is_ready = data.is_ready;
        }
    }
}

export type InternationalRoadShipmentActivityData = {
    id:number|null;
    international_shipment_id:number;
    activity_seq:number;
    perm_shipment_id:number|null;
    shipment_order:number|null;
    start_date:string|null;
    start_time:string|null;
    end_date:string|null;
    end_time:string|null;
    name:string|null;
    address:string|null;
    zip_code:string|null;
    city:string|null;
    county:string|null;
    country_code:string|null;
    // activity_type:string|null;
    real_start_date:string|null;
    real_start_time:string|null;
    real_end_date:string|null;
    real_end_time:string|null;
    truck:string|null;
    trailer:string|null;
    status:string|null;
    status_detail:string|null;
    // is_ready:boolean;
}
